@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.pointofinterest

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.pointsOfIntrest.PointOfInterestDto
object GetAreaPointsOfInterestEndpoint : EndPoint<GetAreaPointsOfInterestEndpoint.Request, GetAreaPointsOfInterestEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
        val startLat: Double,
        val startLng: Double,
        val endLat: Double,
        val endLng: Double,
    )

    class Response(
        val list: Array<PointOfInterestDto>,
        val total: Int
    )
}